<template>
  <!-- Withdraw Modal -->
  <div class="modal custom-fade fade" id="withdraw_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <form @submit.prevent="withdrawFund" class="modal-body">
          <div class="form-header">
            <h3>Withdrawal</h3>
            <div class="form-group text-start mt-2" v-if="settings === 'NGN'">
              <label for="currencyLabel">Wallet</label>

              <select
                class="form-select"
                v-model="withdrawForm.currency"
                required
              >
                <option selected value="">Please select</option>
                <option
                  v-for="(currency, index) in allCurrencyCodes"
                  :key="index"
                  :value="currency"
                >
                  {{ currency }}
                </option>
              </select>
            </div>
            <div class="form-group text-start mt-2">
              <label>Amount</label>
              <input
                type="text"
                v-model="withdrawForm.amount"
                class="form-control"
                placeholder="Enter the Amount"
                required
              />
            </div>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <button
                  type="submit"
                  class="w-100 btn btn-primary"
                  :disabled="isWithdrawing"
                >
                  <span
                    v-if="isWithdrawing"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isWithdrawing">Withdraw</span>
                  <span v-if="isWithdrawing">Withdrawing...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  @click="$emit('closeWithdrawalModal')"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Withdraw Modal -->
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

const allCurrencyCodes = ["NGN", "USD"];
const store = useStore();
const isWithdrawing = ref(false);

const emit = defineEmits(["closeWithdrawalModal", "getTransactions"]);

const settings = computed(() => {
  return store.getters["settings/settings"]?.currency;
});

const withdrawForm = ref({
  currency: "",
  amount: "",
});

const withdrawFund = () => {
  isWithdrawing.value = true;
  if (settings.value !== "NGN") {
    withdrawForm.value.currency = "USD";
  }
  store
    .dispatch("transaction/withdrawFund", withdrawForm.value)
    .then(() => {
      isWithdrawing.value = false;
      emit("closeWithdrawalModal");
      emit("getTransactions");
      withdrawForm.value.amount = "";
      withdrawForm.value.currency = "";
    })
    .catch(() => {
      isWithdrawing.value = false;
      emit("closeWithdrawalModal");
      withdrawForm.value.amount = "";
      withdrawForm.value.currency = "";
    });
};
</script>
